export type result<data> = [string, null] | [null, data];

export namespace result {
    export function error<data>(result: result<data>): result is [string, null] {
        return result[0] !== null;
    }

    export function ok<data>(result: result<data>): result is [null, data] {
        return result[1] !== null;
    }

    export function all<data>(results: result<data>[]): result<data[]> {
        if (results.every(result.ok)) {
            return [null, results.map(([_, data]) => data)];
        } else {
            const errors = results.filter(result.error).map(([error, _]) => error);
            return [errors[0], null];
        }
    }
}
